export const STORAGE_USER_INFO = "user-info";
export const STORAGE_ACCESS_TOKEN = "access-token";
export const STORAGE_REFRESH_TOKEN = "refresh-token";
export const STORAGE_USER_LOCATION = "user-location";
export const STORAGE_USER_LOCATION_KEY = "user-location-key";
export const STORAGE_USER_PERMISSIONS = "user-permissions";
export const LOGIN_TYPE = "login-type";
export const SSO_LOGIN = "sso";
export const CRED_LOGIN = "cred";
export const STORAGE_USERNAME = "user-name";
export const LOGIN_STATUS = "login_status";
export const GIGYA_LOGIN = {
  KEY: "uid-canesmeno",
  ACCESS_TOKEN: "token-canesmeno",
  EVENT: "uid-canesmeno-changed",
};
export const STORAGE_MARKETING_CONSENT = "marketingConsent";
export const STORAGE_WELCOME_VOUCHER_STAGE = "welcome_voucher_stage";
